module.exports = __webpack_public_path__ + "static/mxbcs-5ae6cb87a7a23e46ed37998ddc90fdfa.mp3";